import { render } from "./Explainer.vue?vue&type=template&id=45e6e675&scoped=true"
import script from "./Explainer.vue?vue&type=script&lang=js"
export * from "./Explainer.vue?vue&type=script&lang=js"

import "./Explainer.vue?vue&type=style&index=0&id=45e6e675&scoped=true&lang=css"

import exportComponent from "/home/andre_merino/aihuk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45e6e675"]])

export default __exports__